// extracted by mini-css-extract-plugin
export default {"pillButton":"PillButton_pillButton__b29fy"};